/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { BrowserRouter as Router } from 'react-router-dom';
import * as Sentry from '@sentry/browser';

import { App } from 'blb-components/App';
import { loadConfig, getConfig } from 'blb-utils/config';
import { Provider } from 'react-redux';
import { configureStore } from './redux/configureStore';

import './index.scss';

// eslint-disable-next-line @typescript-eslint/no-floating-promises
(async () => {
  await loadConfig();
  const environment = getConfig().nodeEnv;
  const { sentryKey, sentryHost, sentryProjectId } = getConfig();
  if (sentryKey && sentryHost && sentryProjectId) {
    Sentry.init({
      dsn: `https://${sentryKey}@${sentryHost}/${sentryProjectId}`,
      environment,
    });
  }

  ReactDOM.render(
    <Provider store={configureStore()}>
      <Router>
        <App />
      </Router>
    </Provider>,
    document.getElementById('root'),
  );
})();
